/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import logo from "../Image/logo.png";

const Logo = () => (
  <h2 css={styles}>
    {/* LIFE <span>LIGHT</span> FITNESS */}
    <img src={logo} alt="gym-logo" height={50} width={70}/>
  </h2>
);

const styles = css`
  color: #fff;
  font-size: 30px;
  font-weight: 900;
  line-height: 1;
  cursor: pointer;
  span {
    color: #dd3333;
  }
`;

export default Logo;
